export default [
    {
      path: '/buy-credits',
      name: 'buy-credits',
      component: () => import('@/views/pages/billings/BuyCredits.vue'),
      meta: {
        pageTitle: 'Buy Credits',
        breadcrumb: [
          {
            text: 'Buy Credits',
            active: true,
          }
        ],
        requiresAuth: true,
      },
    },
    {
      path: '/buy-credits/online-payment',
      name: 'online-payment',
      component: () => import('@/views/pages/billings/OnlinePayment.vue'),
      meta: {
        pageTitle: 'Online Payment (Powered by Stencil Pay)',
        breadcrumb: [
          {
            text: 'Buy Credits',
            to: "/buy-credits",
          },
          {
            text: 'Online Payment (Powered by Stencil Pay)',
            active: true,
          },
        ],
        requiresAuth: true,
      },
    },
    {
      path: '/buy-credits/bank-eft',
      name: 'bank-eft',
      component: () => import('@/views/pages/billings/BankEFT.vue'),
      meta: {
        pageTitle: 'Bank EFT Payment Service',
        breadcrumb: [
          {
            text: 'Buy Credits',
            to: "/buy-credits",
          },
          {
            text: 'Bank EFT Payment Service',
            active: true,
          },
        ],
        requiresAuth: true,
      },
    },
    {
      path: '/transaction-history',
      name: 'transaction-history',
      component: () => import('@/views/pages/billings/TransactionHistory.vue'),
      meta: {
        pageTitle: 'Transaction History',
        breadcrumb: [
          {
            text: 'Transaction History',
            active: true,
          }
        ],
        requiresAuth: true,
      },
    },
]